
import Vue from 'vue'
import { k2c } from '@/utils/helper'

interface IData {
  default: any
  attrs: any
}

const component = Vue.extend({
  data(): IData {
    return {
      default: {
        color: 'primary',
        depressed: true,
        textClass: 'noto-sans weight-400'
      },
      attrs: {
        cancel: {
          outlined: true,
          color: 'grey lighten-1',
          textColor: 'black--text'
        },
        secondary: {
          onunload: true,
          rounded: true,
          color: 'm-light-green',
          textColor: 'secondary--text'
        },
        alert: {
          color: 'alert',
          textColor: 'white--text'
        },
        add: {
          color: 'secondary'
        },
        mini: {
          small: true,
          class: 'px-2'
        },
        text: {
          text: true,
          textClass: 'noto-sans weight-400',
          class: 'px-2'
        },
        submit: {
          xLarge: true,
          type: 'submit',
          block: true
        }
      }
    }
  },
  computed: {
    __attrs(): any {
      // ケバブケースをキャメルケースに変換
      const $attrs: any = {}
      for (const key in this.$attrs) {
        $attrs[k2c(key)] = this.$attrs[key]
      }

      // attrsに定義されてる値がkeyとして設定されたらマージ
      const attrs: any = Object.entries($attrs)
        .filter(([key, value]) => (Object.keys(this.attrs).includes(key) ? value === '' || value : false))
        .reduce((acc, cur) => ({ ...acc, ...this.attrs[cur[0]] }), {})

      const classes = `${this.default.class || ''} ${this.$attrs.class || ''} ${attrs.class || ''} ${
        attrs.textColor || ''
      }`

      return {
        ...this.default,
        ...attrs,
        ...$attrs,
        class: classes
      }
    },
    __textAttrs(): any {
      const classes = [
        this.__attrs.textColor ? this.__attrs.textColor : '',
        this.__attrs.textClass ? this.__attrs.textClass : ''
      ]
      return classes.join(' ')
    }
  }
})
Vue.component('ABtn', component)
export default component
